import {WxSdk} from './wx/sdk';

const $swxsdk = new WxSdk();

export {$swxsdk};